import { useEffect } from "react";
import { useAuthStore } from "../../services/useAuthStore";

/**
 * ThemeProvider - Aplica a classe de tema ao body com base nas preferências do usuário
 * Este componente não renderiza nada, ele apenas gerencia o tema
 */
const ThemeProvider = ({ children }) => {
  const preferences = useAuthStore((s) => s.preferences);

  useEffect(() => {
    if (preferences && preferences.preferred_theme) {
      // Remove quaisquer classes de tema existentes
      document.body.classList.remove('theme-light', 'theme-dark');
      // Adiciona a classe de tema atual
      document.body.classList.add(`theme-${preferences.preferred_theme}`);
    } else {
      // Define o tema padrão como claro se nenhuma preferência estiver configurada
      document.body.classList.remove('theme-light', 'theme-dark');
      document.body.classList.add('theme-light');
    }
  }, [preferences]);

  return children;
};

export default ThemeProvider;